// The agent app's black and gray buttons; the dashboard's own classes of those names look different.
export const blackButton =
  "rounded-md border border-textPrimary bg-textPrimary px-3 py-2 text-[12px] text-white transition-opacity duration-200 hover:opacity-80 disabled:cursor-not-allowed disabled:opacity-50";
export const grayButton =
  "rounded-md border border-surfaceMuted bg-surfaceMuted px-3 py-2 text-[12px] text-textSecondary transition-colors duration-200 hover:bg-surfaceSoft disabled:cursor-not-allowed disabled:opacity-50";
